export const PlatformName = 'cordova'; // per l'app su browser
// export const PlatformName = 'mobile'; // per effettuare una build da testare su mobile
// lo switch potrebbe non essere necessario
